module.exports = __webpack_public_path__ + "img/dam-2023-logo.93ce40cf.svg";